<template>
  <div class="min-w-[100px]">
    <template v-if="sanitizedIndicators.length">
      <template v-for="[id, indicator] in sanitizedIndicators" :key="id">
        <CInfoBadge
          v-if="indicator.background_color || indicator.color"
          v-tooltip="indicator.tooltip_text"
          :background-color="indicator.background_color ?? themeVars.base"
          class="mr-1"
          :color="indicator.color ?? themeVars.text"
          inline
          :text="indicator.text"
          :variation="indicator.text ? 'extended' : 'minimal'"
          v-bind="getIconDataForInfoBadge(indicator.icon)"
        />
        <CTag v-else-if="indicator.type" v-tooltip="indicator.tooltip_text" class="mr-2" :type="indicator.type">
          <CIcon v-if="indicator.icon" class="mr-1" v-bind="getIconDataForTag(indicator.icon)" />
          {{ indicator.text }}
        </CTag>
      </template>
    </template>
    <template v-else>-</template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CTag from '@lib/components/CTag/CTag.vue'
import CInfoBadge from '@lib/components/CInfoBadge/CInfoBadge.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import type { CanvasIndicator } from '@lib/types/canvases'
import useThemeVars from '@lib/composables/useThemeVars'
import { getFontAwesomeIconNameAndType } from '@lib/util/font.util'

const props = defineProps<{
  indicators?: Record<string, CanvasIndicator> | null
}>()

const themeVars = useThemeVars()

const sanitizedIndicators = computed(() =>
  Object.entries(props.indicators || {}).filter(([, indicator]) => !!indicator?.text || !!indicator?.icon),
)

function getIconProps(icon: string) {
  const iconInfo = getFontAwesomeIconNameAndType(icon)
  return {
    faType: iconInfo.type,
    icon: iconInfo.name,
  }
}

function getIconDataForInfoBadge(icon?: string) {
  if (!icon) return {}
  return getIconProps(icon)
}

function getIconDataForTag(icon: string) {
  return getIconProps(icon)
}
</script>
